<div *ngIf="childConfig.config.isSupportDynamic" class="label-bac" (click)="clickAddCtrol($event)">
    <label>{{childConfig.config.addlabel}}</label>
</div>
<div *ngIf="!childConfig.config.isHidden" [style.width.px]="childConfig.css.width">
    <div class="tml-tpl-ctrl-wrap">
        <!--Job Title-->
        <div class="tam-contact-control" tid="former-job-title">
            <label>Job Title</label>
            <div>
                <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth"
                    [popupSettings]="{appendTo: 'component'}" #dropDownElJobTitle class="contact-dropdown"
                    [data]="jobTitleSuggestionItems" [filterable]="true" (filterChange)="handleFilter($event,0)"
                    [textField]="'name'" [valueField]="'id'" [(ngModel)]="jobTitleSelectedItem"
                    (focus)="dropDownElJobTitle.toggle(true)" (valueChange)="valueChangeJobTitle($event)"
                    (keydown.esc)="onEnter($event)" (mousedown)="$event.preventDefault()">
                    <ng-template kendoMultiSelectHeaderTemplate>
                        <div class="popup-template-clear-header">
                            <span class="multiselect-Clear" (click)="clearValue(0)">Clear</span>
                        </div>
                    </ng-template>
                    <div>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span>{{dataItem.name}} </span>
                            <span *ngIf="dataItem.id === searchId">(New Job Title)</span>
                        </ng-template>
                    </div>
                </kendo-dropdownlist>
            </div>
        </div>
        <!--Compnay-->
        <div class="tam-contact-control" tid="former-company">
            <label>Company</label>
            <div>
                <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidth"
                    [popupSettings]="{appendTo: 'component'}" #dropDownElCompany class="contact-dropdown"
                    [data]="companySuggestionItems" [filterable]="true" (filterChange)="handleFilter($event,1)"
                    [textField]="'name'" [valueField]="'id'" [(ngModel)]="companySelectedItem"
                    (focus)="dropDownElCompany.toggle(true)" (valueChange)="valueChangeCompany($event)"
                    (keydown.esc)="onEnter($event)" (mousedown)="$event.preventDefault()">

                    <ng-template kendoMultiSelectHeaderTemplate>
                        <div class="popup-template-clear-header">
                            <span class="multiselect-Clear" (click)="clearValue(1)">Clear</span>
                        </div>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                        <tam-entity-dropdown-item [entity]="dataItem">
                        </tam-entity-dropdown-item>
                    </ng-template>

                    <ng-template kendoDropDownListFooterTemplate>
                        <div *ngIf="searchItem" class="dropdown-fly-item" (click)="createEntity()">
                            <span>{{searchItem}} (New Company)</span>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
        </div>
        <div class="trash-icon">
            <smart-icon *ngIf="childConfig.config.isCanDelete" name="trash" (click)="clickRemoveLayout($event)">
            </smart-icon>
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <!--useless-->
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth"
                [style.height.px]="childConfig.heigh" />
        </div>
        <!--start end year-->
        <div class="tam-contact-control" tid="start-year">
            <label>Start Year</label>
            <div>
                <kendo-dropdownlist #dropDownSYear [style.width.px]="childConfig.css.rightWidthYear"
                    [(ngModel)]="sYearSelectedItem" [data]="sYearSuggestionItems"
                    (valueChange)="valueChangeStartYear($event)" [filterable]="true"
                    (filterChange)="handleFilter($event,2)" (focus)="dropDownSYear.toggle(true)"
                    (mousedown)="$event.preventDefault()">
                    <ng-template kendoMultiSelectHeaderTemplate>
                        <div class="popup-template-clear-header">
                            <span class="multiselect-Clear" (click)="clearValue(2)">Clear</span>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
        </div>
        <div class="tam-contact-control" tid="end-year">
            <label>End Year<span style="color:red;">&nbsp;*</span></label>
            <div>
                <kendo-dropdownlist #dropDownEYear [style.width.px]="childConfig.css.rightWidthYear"
                    [(ngModel)]="eYearSelectedItem" [data]="eYearSuggestionItems"
                    (valueChange)="valueChangeEndYear($event)" [filterable]="true"
                    (filterChange)="handleFilter($event,3)" (focus)="dropDownEYear.toggle(true)"
                    (mousedown)="$event.preventDefault()">
                    <ng-template kendoMultiSelectHeaderTemplate>
                        <div class="popup-template-clear-header">
                            <span class="multiselect-Clear" (click)="clearValue(3)">Clear</span>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
            <label [hidden]="!hintContent" class="item-label-error">
                {{hintContent}}
            </label>
        </div>
    </div>
</div>